import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-49981afe"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "new-account-wrapper" }
const _hoisted_2 = { class: "form-content" }
const _hoisted_3 = { class: "mb-8" }

import { ref } from 'vue'

import {
  Description,
  Password,
  Label,
  Error,
} from '@/popup/components/shared/Form/Form'
import Button from '@/popup/components/shared/Button.vue'
import { InputError } from '@/popup/components/shared/Form/FormTypes'
import CreatePassword from '@/popup/components/shared/Password/CreatePassword.vue'
import { useGlobals } from '@/popup/compositions/useGlobals'
import { InternalMethods } from '@/shared/apis/messages'
import { t } from '@/popup/lib/i18n'

type ChangePasswordEvent = {
  (
    event: InternalMethods.CHANGE_PASSWORD,
    existing: string,
    newPassword: string
  ): void
}


export default /*#__PURE__*/_defineComponent({
  __name: 'ChangeExistingPassword',
  setup(__props, { emit: __emit }) {

const emitChangePassword = __emit

const existingPassword = ref('')
const newPassword = ref('')
const existingPasswordErrors = ref<InputError[]>([])
const isNewPasswordPassed = ref(false)

const globals = useGlobals()

const updatePassword = (password: string, passed: boolean) => {
  newPassword.value = password
  isNewPasswordPassed.value = passed
}

const onSubmit = async () => {
  if (!isNewPasswordPassed.value) return
  const valid = await globals.sendMessage({
    method: InternalMethods.VALIDATE_PASSWORD,
    payload: {
      password: existingPassword.value,
    },
  })
  existingPasswordErrors.value = [t('backend.unlock.incorrect_password')]
  if (valid) {
    emitChangePassword(
      InternalMethods.CHANGE_PASSWORD,
      existingPassword.value,
      newPassword.value
    )
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Transition, {
    name: "fade",
    mode: "out-in"
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("h2", null, _toDisplayString(_ctx.$t('authenticate.password.label')), 1 /* TEXT */),
        _createElementVNode("form", {
          onSubmit: _withModifiers(onSubmit, ["prevent"])
        }, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createVNode(_unref(Label), {
                "extra-class": "is-title mb-2",
                label: _ctx.$t('settings.password.existing_password')
              }, null, 8 /* PROPS */, ["label"]),
              _createVNode(_unref(Password), {
                name: "existingPassword",
                password: existingPassword.value,
                "onUpdate:password": [
                  _cache[0] || (_cache[0] = ($event: any) => ((existingPassword).value = $event)),
                  _cache[1] || (_cache[1] = 
                () => {
                  existingPasswordErrors.value = []
                }
              )
                ],
                autofocus: true,
                validators: [],
                errors: existingPasswordErrors.value,
                class: _normalizeClass(existingPasswordErrors.value.length > 0 ? 'has-error' : '')
              }, null, 8 /* PROPS */, ["password", "errors", "class"]),
              (existingPasswordErrors.value?.length)
                ? (_openBlock(), _createBlock(_unref(Error), {
                    key: 0,
                    error: existingPasswordErrors.value[0]
                  }, null, 8 /* PROPS */, ["error"]))
                : _createCommentVNode("v-if", true)
            ]),
            _createElementVNode("div", null, [
              _createVNode(_unref(Label), {
                "extra-class": "is-title mb-2",
                label: _ctx.$t('settings.password.new_password')
              }, null, 8 /* PROPS */, ["label"]),
              _createVNode(_unref(Description), {
                description: _ctx.$t('create_new_account.password_description')
              }, null, 8 /* PROPS */, ["description"]),
              _createVNode(CreatePassword, { onUpdatePassword: updatePassword })
            ])
          ]),
          _createVNode(Button, {
            disabled: !isNewPasswordPassed.value,
            variant: "primary",
            "is-full-width": true,
            type: "submit",
            onClick: onSubmit
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('create_new_account.continue')), 1 /* TEXT */)
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["disabled"])
        ], 32 /* NEED_HYDRATION */)
      ])
    ]),
    _: 1 /* STABLE */
  }))
}
}

})